import React from 'react';
import Icon from '../../../components/AppIcon';

const SchedulingPanel = ({ upcomingReports, onGenerateNow }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Calendar" size={24} color="var(--color-primary)" />
        <h2 className="text-xl font-semibold text-foreground">Upcoming Reports</h2>
      </div>
      <div className="space-y-4">
        {upcomingReports?.map((report) => (
          <div key={report?.id} className="p-3 border border-border rounded-lg">
            <div className="flex items-start justify-between mb-2">
              <div className="flex-1">
                <h3 className="text-sm font-semibold text-foreground mb-1">{report?.name}</h3>
                <div className="flex items-center gap-2 text-xs text-muted-foreground">
                  <Icon name="Clock" size={12} />
                  <span>{report?.scheduledDate}</span>
                  <span className="w-1 h-1 rounded-full bg-muted-foreground" />
                  <span>{report?.type}</span>
                </div>
              </div>
              <span
                className={`px-2 py-1 rounded text-xs font-medium ${
                  report?.validation === 'complete'
                    ? 'bg-success/10 text-success' :'bg-warning/10 text-warning'
                }`}
              >
                {report?.validation === 'complete' ? 'Ready' : 'Pending'}
              </span>
            </div>
            <div className="flex items-center justify-between pt-2 border-t border-border">
              <div className="flex items-center gap-1 text-xs text-muted-foreground">
                <Icon name="Users" size={12} />
                <span>{report?.recipients} recipients</span>
              </div>
              <button
                onClick={() => onGenerateNow?.(report)}
                className="text-xs text-primary hover:text-primary/80 font-medium"
              >
                Generate Now
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SchedulingPanel;